import PropTypes from 'prop-types';
import cx from 'classnames';
// import { defineMessages, useIntl } from 'react-intl';
import { accessibleOnClick } from '@package/helpers/accessibleOnClick';

// import styles from './GroupHeader.module.less';

// const messages = defineMessages({
//   siteName: { id: 'G20 Portal', defaultMessage: 'G20 Portal' },
// });

// TODO: i18n
const GroupHeader = ({
  title,
  description,
  logo,
  active,
  collapsible,
  onClick,
}) => {
  // const intl = useIntl();

  if (!title && !logo) return null;

  // I18N
  return (
    <div
      className={cx('group-header', {
        open: collapsible && active,
        close: collapsible && !active,
      })}
      {...accessibleOnClick((event) => {
        event.preventDefault();
        onClick();
      })}
    >
      {title && !logo && (
        <div className="wrapper">
          <div className="title">{title}</div>
          <div className="description">{description}</div>
        </div>
      )}

      {/* {logo && (
        <div className='logo'>
          <LogoG20
            title={intl.formatMessage(messages.siteName)}
            titleId="g20-menu-logo"
          />
        </div>
      )} */}

      <div className="logo">COP30</div>

      {collapsible && (
        <span className="br-button circle small">
          <i
            className={`fa-solid fa-${active ? 'angle-up' : 'angle-down'}`}
          ></i>
        </span>
      )}
    </div>
  );
};

GroupHeader.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  logo: PropTypes.bool,
  active: PropTypes.bool,
  collapsible: PropTypes.bool,
  onClick: PropTypes.func,
};

export default GroupHeader;
